<template>
  <div class="read-list">
    <el-dialog
      title="已读列表"
      :visible="readListShow"
      width="30%"
      @close="dialogClose"
    >
      <el-table :data="readList" max-height="500px" style="width: 100%">
        <el-table-column prop="userName" label="姓名" width="180">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{ scope.row.readFlag == 0 ? "未读" : "已读" }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
  
<script>
export default {
  name: "",
  props: ["readListShow", "readList"],
  data() {
    return {};
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:readListShow", false);
    },
  },
};
</script>
  
<style lang="scss" scoped >
@import "./readList.scss";
</style>